import { FC } from 'react';

import { Icon } from './Icon';
import { SvgIcon } from './SvgIcon.type';

export const IconThumbsUp: FC<SvgIcon> = (props) => (
  <Icon {...props} viewBox="0 0 24 24" name="thumbs-up">
    <path
      fillRule="evenodd"
      d="M17.93 2.744a.5.5 0 0 0-.86 0l-1.028 1.728-1.364 1.145a.5.5 0 0 0 0 .766l1.364 1.145 1.028 1.728a.5.5 0 0 0 .86 0l1.028-1.728 1.364-1.145a.5.5 0 0 0 0-.766l-1.364-1.145-1.028-1.728Zm-1.072 2.312.642-1.078.642 1.078a.5.5 0 0 0 .108.127l.973.817-.973.817a.5.5 0 0 0-.108.127L17.5 8.022l-.642-1.078a.5.5 0 0 0-.108-.127L15.777 6l.973-.817a.5.5 0 0 0 .108-.127Z"
      clipRule="evenodd"
    />
    <path d="M9.628 4.5a2.21 2.21 0 0 0-2.032 1.34L5.3 11.196a.5.5 0 0 1-.46.303H4v1h.84a1.5 1.5 0 0 0 1.38-.91l2.295-5.357a1.21 1.21 0 0 1 2.26.86l-.81 2.433a1.5 1.5 0 0 0 1.422 1.974h4.226a.5.5 0 0 1 .474.658l-2.333 7a.5.5 0 0 1-.475.342H7.736a.5.5 0 0 1-.224-.053l-1.577-.789a1.5 1.5 0 0 0-.671-.158H4v1h1.264a.5.5 0 0 1 .224.053l1.577.789a1.5 1.5 0 0 0 .671.158h5.543a1.5 1.5 0 0 0 1.423-1.026l2.334-7a1.5 1.5 0 0 0-1.423-1.974h-4.226a.5.5 0 0 1-.474-.658l.811-2.433A2.21 2.21 0 0 0 9.628 4.5Z" />
  </Icon>
);
